import gql from 'graphql-tag'
import api from '../apiClient'

export default {
  list: value =>
    api
      .send({
        query: gql`
          query cantonByProvincia($idProvincia: String!) {
            TYPES {
              Canton {
                readByProvincia(idProvincia: $idProvincia) {
                  id
                  value
                  annotation
                  codigo
                  idProvincia
                }
              }
            }
          }
        `,
        variables: {
          idProvincia: value
        }
      })
      .then(result => result.data.data.TYPES.Canton.readByProvincia)
}
